/// <reference path="../walkinManager.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />


module Meevo.Plugins.WalkinManager.SendSms {
    import IWalkinAppointment = Meevo.Plugins.WalkinManager.IWalkinAppointment;

    class SendSmsModalController {
        static $inject = [
            '$scope', 'item', '$mdDialog', 'meevo.components.common.DataService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService'
        ];
        public item: IWalkinAppointment;
        protected $mdDialog: ng.material.IDialogService;
        public searchCriteria: any;
        public currentEmployee: any;
        public smsBody: string;

        constructor(
            protected $scope: ng.IScope,
            item: IWalkinAppointment,
            $mdDialog: ng.material.IDialogService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService
        ) {
            this.$mdDialog = $mdDialog;
        };

        public send(): void {
            this.busyService.start('Sending SMS');
            var request = {
                sendOnDemandSmsNotification: true,
                services: [ this.item ],
                smsInfo: {
                    messageBody: this.smsBody,
                    recipientPhoneNumber: '+' + this.item.clientPrimaryCountryCode + this.item.clientPrimaryPhoneNumber,
                    clientId: this.item.clientId
                }
            };
            this.dataService.add('walkinSms', request)
                .finally(() => {
                    this.busyService.stop();
                    this.$mdDialog.hide();
                });
        }

        public closeModal(): void {
            this.$mdDialog.cancel();
        };
    }

    angular.module('meevo.plugins.walkinManager')
        .controller('meevo.plugins.walkinManager.sendSms.SendSmsModalController', SendSmsModalController);
}
